import React, { type ReactElement } from 'react';

import ProPerkWithButton from './ProPerkWithButton';
import { SUBSCRIBE_BUTTON_TEXT, UPGRADE_BUTTON_TEXT, getCTAPath } from './constants';
import { ProPerks } from './constants';
import { ProCTAProps } from './interfaces';

const ProCTA = ({
  initialCurrentUser,
  isProSubscriberNotBot,
  proOfferCode,
}: ProCTAProps): ReactElement => {
  const isSubscriber = initialCurrentUser?.is_subscriber;

  return (
    <div className="mt-48 border-0 border-t border-solid border-grayscale-beige pt-48 sm:px-40 md:px-0 lg:px-28">
      <h2 className="mx-auto my-0 max-w-[660px] text-center font-suisse-works text-headline-xs text-primary-black sm:mb-24 sm:text-headline-md lg:max-w-full">
        Better decision-making starts with <span className="block">The Information Pro</span>
      </h2>
      <ProPerkWithButton
        buttonText={isSubscriber ? UPGRADE_BUTTON_TEXT : SUBSCRIBE_BUTTON_TEXT}
        link={getCTAPath(isSubscriber, proOfferCode)}
        isProSubscriberNotBot={isProSubscriberNotBot}
        {...ProPerks.insights}
      />
    </div>
  );
};

export default ProCTA;
